import { render, staticRenderFns } from "./ManuscriptEditorMenuDialog.vue?vue&type=template&id=0bb29f6b&scoped=true"
import script from "./ManuscriptEditorMenuDialog.vue?vue&type=script&lang=ts"
export * from "./ManuscriptEditorMenuDialog.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptEditorMenuDialog.vue?vue&type=style&index=0&id=0bb29f6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb29f6b",
  null
  
)

export default component.exports